export const calculatePercent = (pastValue: number, actualValue: number) => {
    return Math.round(100 * ((actualValue - pastValue) / Math.abs(pastValue)));
};

export const getPercentString = (percent: number) => {
    if (percent !== 0) {
        return `${percent}%`;
    }

    return "";
};

export const getPercentMeaning = (percent: number) => {
    if (percent > 0) {
        return `wzrost`;
    }

    if (percent < 0) {
        return `spadek`;
    }

    return `stagnację`;
};

export const getPercentMoreLess = (percent: number) => {
    if (percent > 0) {
        return `więcej`;
    }

    if (percent < 0) {
        return `mniej`;
    }

    return ``;
};
export const calculatePercent = (pastValue: number, actualValue: number) => {
    return Math.round(100 * ((actualValue - pastValue) / Math.abs(pastValue)));
};

export const getPercentString = (percent: number) => {
    if (percent !== 0) {
        return `${percent}%`;
    }

    return "";
};

export const getPercentMeaning = (percent: number) => {
    if (percent > 0) {
        return `wzrost`;
    }

    if (percent < 0) {
        return `spadek`;
    }

    return `stagnację`;
};

export const getPercentMoreLess = (percent: number) => {
    if (percent > 0) {
        return `więcej`;
    }

    if (percent < 0) {
        return `mniej`;
    }

    return ``;
};
